import { shallowRef } from 'vue'

/**
 * What the current IDP page wants the sidebar to show about itself. Set by the
 * page on mount and cleared on unmount, so the sidebar never shows a stale team.
 */
export interface TeamNav {
  key: string
  name: string
  /** Open actionable insights, or null while loading. */
  insights: number | null
  /** Set on the sub-team page, which lists the sub-team's own views. */
  subTeam?: { key: string; name: string }
}

export const teamNav = shallowRef<TeamNav | null>(null)

/** Set by the workspace page, for its section of the sidebar. */
export interface WorkloadNav {
  service: string
  /** The route query the workspace was opened with, reused by each tab link. */
  query: Record<string, string>
}

export const workloadNav = shallowRef<WorkloadNav | null>(null)
